import { RULE_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const ruleSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RULE_SCHEMA_ACTION_TYPE.GET_RULE_SCHEMA_PARAMS:
      return payload || initialState;

    default:
      return state;
  }
};

export default ruleSchemaReducer;
